package org.catharsis.spendtel.feature.presentation

import androidx.compose.runtime.Composable
import androidx.navigation.NavHostController
import org.catharsis.spendtel.feature.presentation.web.WebHomeScreen

@Composable
actual fun HomeScreen(navHostController: NavHostController) {
    WebHomeScreen(navHostController)
}
